import { SmartDmMeasurementParser } from './SmartDmMeasurementParser';
import type { ParsedData } from '../../../../interfaces/toolData';

/**
 * Parser for JAE Smart DM TEMP files
 * 
 * Handles temperature measurements including:
 * - TEMPERATURE_PCB_C (PCB temperature)
 * - TEMPERATURE_SENSORS_C (Sensor temperature)
 */
export class SmartDmTempParser {
  static parse(fileContent: string): ParsedData {
    const unitMappings = {
      'TEMPERATURE_PCB_C': '°C',
      'TEMPERATURE_SENSORS_C': '°C'
    };
    
    return SmartDmMeasurementParser.parse(
      fileContent,
      'TEMP',
      'JAE_SMARTDM_TEMP',
      unitMappings
    );
  }
} 